<div class="bina-catalog-calculator">
  <div class="bina-catalog-calculator__header">
    <div class="bina-catalog-calculator__header-text">
      {{ "LABELS.TAX_AND_DUTIES_CALCULATOR" | translate }}
    </div>
    <div class="bina-catalog-calculator__header-close" (click)="close.emit()">×</div>
  </div>

  <div class="bina-catalog-calculator__content">
    <div
      *ngIf="showEstimatedDutiesAndTariffs"
      class="bina-catalog-calculator__estimated-duties-and-tariffs"
      [ngClass]="{ 'no-bottom-padding': showEstimatedDutiesAndTariffsTotal }"
    >
      <p class="bina-catalog-calculator__estimated-duties-and-tariffs__title">
        {{ "LABELS.ESTIMATED_DUTIES_AND_TARIFFS" | translate }}
      </p>

      <div class="bina-catalog-calculator__estimated-duties-and-tariffs__sections">
        <!--General rate-->
        <div class="bina-catalog-calculator__estimated-duties-and-tariffs__section" *ngIf="!isShowOnlySpecialTariffRate">
          <p class="bina-catalog-calculator__estimated-duties-and-tariffs__value">
            {{ dutiesCalculation?.estimatedDutiesAmount | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.0-2" }}
          </p>
          <span class="bina-catalog-calculator__estimated-duties-and-tariffs__label">
            {{ "LABELS.GENERAL_RATE" | translate }} {{ dutiesCalculation?.generalRate }}
          </span>
        </div>

        <!--Special rate-->
        <div
          class="bina-catalog-calculator__estimated-duties-and-tariffs__section"
          *ngIf="showSpecialTariffRate || isShowOnlySpecialTariffRate"
        >
          <p class="bina-catalog-calculator__estimated-duties-and-tariffs__value">
            {{ dutiesCalculation?.specialTariffDutiesAmount | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.0-2" }}
          </p>
          <span class="bina-catalog-calculator__estimated-duties-and-tariffs__label">
            {{ specialTariffRateTranslationText | translate | titlecase }}: {{ dutiesCalculation?.specialTariffRate }}
          </span>
        </div>
      </div>
      <div *ngIf="favoriteHtsNumber?.isSubjectToQuota" class="bina-catalog-calculator__notification-box">
        <app-notification-box
          iconImage="/assets/icons/icon_attention_sm.svg"
          description="LABELS.HTS_IS_SUBJECT_TO_QUOTAS_WARNING"
        ></app-notification-box>
      </div>
      <div *ngIf="isShowChinaDisclaimer" class="bina-catalog-calculator__notification-box">
        <app-notification-box
          iconImage="/assets/icons/icon_attention_sm.svg"
          description="LABELS.HTS_CHINA_DISCLAIMER"
        ></app-notification-box>
      </div>
      <p *ngIf="showEstimatedDutiesAndTariffsTotal" class="bina-catalog-calculator__estimated-duties-and-tariffs__total">
        {{ "BINA_CATALOG.TOTAL_ESTIMATED_DUTIES" | translate }} -
        {{ estimatedDutiesAndTariffsTotal | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.0-2" }}
      </p>
    </div>

    <app-hts-code-card
      class="bina-catalog-calculator-sidebar__card"
      [favoriteHtsNumber]="favoriteHtsNumber"
      [isShowMoreEnabled]="false"
      [isAlwaysTruncated]="true"
      [descriptionCharLimit]="37"
    ></app-hts-code-card>
    <form [formGroup]="calculatorForm" (ngSubmit)="onCalculate()">
      <auto-select
        id="countryOfOriginId"
        bindValue="id"
        class="custom"
        [fc]="calculatorForm.get('countryOfOriginId')"
        [label]="'FORM_LABEL.COUNTRY_OF_ORIGIN'"
        labelClass="font-medium-weight"
        [bindLabel]="['description']"
        [change]="searchCountry()"
        [initializeItems]="[]"
        [placeholder]="'FORM_PLACEHOLDER.SELECT' | translate"
        [helper]="'FORM_HELPER.COUNTRY_OF_ORIGIN' | translate"
      ></auto-select>

      <div class="row no-gutters">
        <ng-container *ngIf="!!showQuantityField">
          <app-control-wrapper classGroup="mt-2 mb-0 mr-3" [control]="calculatorForm.get('quantity1')" [isShowHelper]="false">
            <label class="bina-catalog-calculator__label" for="quantity1" control-label>{{ "LABELS.QUANTITY" | translate }}</label>
            <input
              control-wrapper
              id="quantity1"
              class="form-control"
              formControlName="quantity1"
              type="text"
              inputmode="numeric"
              [placeholder]="'LABELS.QUANTITY' | translate"
              [pattern]="DECIMAL_INPUT_MAP.pattern"
              [mask]="DECIMAL_INPUT_MAP.mask"
              [dropSpecialCharacters]="false"
              [appMaskErrorTooltip]="DECIMAL_INPUT_MAP.maskErrorTooltip"
            />
          </app-control-wrapper>
        </ng-container>
        <div class="bina-catalog-calculator__side-label-input-wrapper">
          <app-control-wrapper classGroup="mt-2 mb-0" [control]="calculatorForm.get('estimatedGoodsValue')" [isShowHelper]="false">
            <label class="bina-catalog-calculator__label" control-label for="estimatedGoodsValue">
              {{ "FORM_LABEL.ESTIMATED_GOODS_VALUE" | translate }}
            </label>
            <input
              control-wrapper
              type="text"
              id="estimatedGoodsValue"
              class="bina-catalog-calculator__input estimated-goods-value form-control"
              name="estimatedGoodsValue"
              formControlName="estimatedGoodsValue"
              appMaskErrorTooltip="MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL"
              mask="0*"
              [placeholder]="'LABELS.ESTIMATED' | translate"
              [dropSpecialCharacters]="false"
              [patterns]="CUSTOM_MASK"
              [appMaskErrorTooltip]="'MASK_ERROR.ONLY_DIGITS'"
            />
          </app-control-wrapper>

          <div class="bina-catalog-calculator__input-side-label">
            <span>{{ DEFAULT_CURRENCY_CODE }}</span>
          </div>
        </div>
      </div>

      <button type="submit" class="btn btn-primary bina-catalog-calculator__input-button" [disabled]="isCalculateDisabled">
        <img alt="calculate" src="/assets/icons/icon_calculator_white.svg" />
        {{ "BUTTON.CALCULATE" | translate | uppercase }}
      </button>
    </form>
  </div>
</div>
